import { useCallback } from "react";

import { ApolloError, useMutation } from "@apollo/client";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";
import { orchestrationPathResources } from "Pages/orchestration/Pages/orchestrationPaths";
import { renderErrorMessage } from "Services/LoggingService";
import { restoreJourney } from "Services/marketing-api/journeys/mutations";

export const useRestoreJourneyVersion = () => {
    const navigate = useNavigate();

    const [restoreJourneyVersion, { loading }] = useMutation(restoreJourney);

    const restoreVersion = useCallback(
        async (id: string, version: string) => {
            try {
                const { data } = await restoreJourneyVersion({
                    variables: {
                        input: {
                            id,
                            version: +version,
                        },
                    },
                });
                message.success("Journey version restored.");
                navigate(
                    `${AppPagePaths.orchestration}/${orchestrationPathResources.journeys}/${data?.restoreJourney?.id}`
                );
                return true;
            } catch (e) {
                const error = e as ApolloError;
                renderErrorMessage({ content: "Journey version restore failed.", error, logAsWarn: true });
                return false;
            }
        },
        [navigate, restoreJourneyVersion]
    );

    return {
        loading,
        restoreVersion,
    };
};
